export function inside(point, zone) {
    const x = point[0], y = point[1];

    function insideRing(vs) {
        let inside = false;
        for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            const xi = vs[i][0], yi = vs[i][1];
            const xj = vs[j][0], yj = vs[j][1];
            const intersect = ((yi > y) !== (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    }

    // Legacy array format: flat array of [lon, lat] pairs
    if (Array.isArray(zone)) {
        return insideRing(zone);
    }

    // GeoJSON Polygon: coordinates is array of rings, first is outer boundary
    if (zone.type === 'Polygon') {
        return insideRing(zone.coordinates[0]);
    }

    // GeoJSON MultiPolygon: inside if inside any polygon's outer ring
    if (zone.type === 'MultiPolygon') {
        return zone.coordinates.some(polygon => insideRing(polygon[0]));
    }

    return false;
}

export function computeLinearDistance({latitude: lat1, longitude: lon1}, {latitude: lat2, longitude: lon2}) {
    const deg2rad = function (deg) {
        return deg * (Math.PI / 180);
    }
    const R = 6371000; // Radius of the earth in m
    const dLat = deg2rad(lat1 - lat2);
    const dLon = deg2rad(lon1 - lon2);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat2)) * Math.cos(deg2rad(lat1)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in m
    return d;
}